<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 bg-gray-300
        h-500 overflow-scroll
        border-400 border-t shadow-400 py-2 px-5"
         ref="msgBoxContainer">
<!--      this.$refs.msgBoxContainer-->
        <div class="my-2 w-100"
             v-for="message in formatedMessages"
             :key="message.id">
          <div :class="['d-flex', user.uid== message.userId? ' justify-content-end':'']">
            <div class="message-box w-45">
              <small class="fw-bold" v-if="user.uid!=message.userId">{{ message.name }}</small>
              <div :class="['message p-2', user.uid== message.userId? 'border-my-msg':'border-other-msg']">
                <p class="mb-0 mx-2">{{ message.message }}</p>
              </div>
              <small :class="['text-black-50 fw-light fs-10', user.uid== message.userId? 'float-start':'float-end']">
                {{ message.created_at}}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/config";
import {computed, onUpdated, ref} from "vue";
import {formatDistanceToNow} from "date-fns";
import getUser from "@/composables/getUser";

export default {
  name: "ChatWindow",
  setup(){
    let messages = ref([]);
    let {user} = getUser();
    let msgBoxContainer = ref(null);
    // auto scrolling feature
    onUpdated(()=>{
      // console.log(msgBoxContainer.value.scrollTop); => 0
      // console.log(msgBoxContainer.value.scrollHeight); => 654
      msgBoxContainer.value.scrollTop = msgBoxContainer.value.scrollHeight;
    })

    let formatedMessages = computed(()=>{
      return messages.value.map((message)=>{ // map make new array with looping
        let formatTime = formatDistanceToNow(message.created_at.toDate())
        return {...message, created_at: formatTime}; // overwrite created_at
      })
    });
    db.collection('messages')
        .orderBy('created_at')
        .onSnapshot((snap)=>{
          let results = [];
          snap.docs.forEach((doc)=>{
            // console.log(doc);
            let document = {...doc.data(), id:doc.id};
            console.log(document);
            // if (doc.data().created_at){
            //   results.push(document);
            // }
            doc.data().created_at && results.push(document); // same
          })
          messages.value = results;
    })
    return { messages, formatedMessages, msgBoxContainer, user };
  }
}
</script>

<style scoped>
.border-t{
  border-radius: 10px 10px 0 0;
}
.border-400{
  border: 2px solid #cbd5e1;
}
.shadow-400{
  box-shadow: 2px 3px 10px #cbd5e1;
}
.message{
  background: #cbd5e1;
}
.border-other-msg{
  border-radius: 0 15px 15px;
}
.border-my-msg{
  border-radius: 15px 0 15px 15px;
}
.fs-10{
  font-size: 10px !important;
}
.h-500{
  height: 500px;
}
.w-45{
  width: 45% !important;
}
</style>